export const USER_LOGIN = 'USER_LOGIN';
export const USER_LOGOUT = 'USER_LOGOUT';
export const USER_REGISTER = 'USER_REGISTER';

export const GET_RECORDS = 'GET_RECORDS';
export const SET_RECORDS = 'SET_RECORDS';

export const GET_APP_LIST = 'GET_APP_LIST';
export const SET_APP_LIST = 'SET_APP_LIST';
export const GET_GOODS_LIST = 'GET_GOODS_LIST';
export const SET_GOODS_LIST = 'SET_GOODS_LIST';
export const GET_USER_PLAYED_GAME = 'GET_USER_PLAYED_GAME';
export const SET_USER_PLAYED_GAME = 'SET_USER_PLAYED_GAME';
export const GET_SERVER_LIST = 'GET_SERVER_LIST';
export const SET_SERVER_LIST = 'SET_SERVER_LIST';
export const GET_ROLE_INFO = 'GET_ROLE_INFO';
export const EG_BUY_GOODS = 'EG_BUY_GOODS';



// WEBPACK FOOTER //
// ./src/store/mutation-types.js